// The size and stroke of each toolbar icon.

export const defaultIconStyles: Record<string, { size: number; strokeWidth: number }> = {
  undo: { size: 14, strokeWidth: 1.4 },
  redo: { size: 14, strokeWidth: 1.4 },
  paragraph: { size: 14, strokeWidth: 1.75 },
  heading1: { size: 14, strokeWidth: 1.75 },
  heading2: { size: 14, strokeWidth: 1.75 },
  heading3: { size: 14, strokeWidth: 1.75 },
  heading4: { size: 14, strokeWidth: 1.75 },
  heading5: { size: 14, strokeWidth: 1.75 },
  heading6: { size: 14, strokeWidth: 1.75 },
  blockquote: { size: 14, strokeWidth: 1.75 },
  codeBlock: { size: 14, strokeWidth: 1.75 },
  font: { size: 13, strokeWidth: 1.4 },
  fontSize: { size: 14, strokeWidth: 1.75 },
  fontColor: { size: 14, strokeWidth: 1.4 },
  highlightColor: { size: 14, strokeWidth: 1.4 },
  bold: { size: 13, strokeWidth: 1.75 },
  italic: { size: 13, strokeWidth: 1.4 },
  underline: { size: 13, strokeWidth: 1.4 },
  strikethrough: { size: 14, strokeWidth: 1.4 },
  subscript: { size: 14, strokeWidth: 1.75 },
  superscript: { size: 14, strokeWidth: 1.75 },
  inlineCode: { size: 14, strokeWidth: 1.4 },
  alignLeft: { size: 14, strokeWidth: 1.5 },
  alignCenter: { size: 14, strokeWidth: 1.5 },
  alignRight: { size: 14, strokeWidth: 1.5 },
  justify: { size: 14, strokeWidth: 1.5 },
  bulletList: { size: 14, strokeWidth: 1.5 },
  orderedList: { size: 14, strokeWidth: 1.5 },
  taskList: { size: 14, strokeWidth: 1.4 },
  horizontalRule: { size: 14, strokeWidth: 1.5 },
  link: { size: 14, strokeWidth: 1.4 },
  image: { size: 14, strokeWidth: 1.4 },
  table: { size: 14, strokeWidth: 1.4 },
  details: { size: 14, strokeWidth: 1.4 },
  dragHandle: { size: 14, strokeWidth: 1.4 },
  versionHistory: { size: 14, strokeWidth: 1.4 },
  save: { size: 13, strokeWidth: 1.3 },
  exportClipboard: { size: 13, strokeWidth: 1.3 },
  exportFormatted: { size: 13, strokeWidth: 1.3 },
  exportMarkdown: { size: 13, strokeWidth: 1.3 },
  publishPost: { size: 13, strokeWidth: 1.3 },
  exportODT: { size: 13, strokeWidth: 1.2 },
  exportDOCX: { size: 13, strokeWidth: 1.2 },
  exportPDF: { size: 13, strokeWidth: 1.2 },
  exportEPUB: { size: 13, strokeWidth: 1.2 },
  exportTXT: { size: 13, strokeWidth: 1.2 },
  exportJSON: { size: 13, strokeWidth: 1.2 },
  importDocument: { size: 13, strokeWidth: 1.25 },
  settings: { size: 13, strokeWidth: 1.3 },
  minimizeWindow: { size: 12, strokeWidth: 1.8 },
  maximizeWindow: { size: 12, strokeWidth: 1.5 },
  closeWindow: { size: 10, strokeWidth: 1.5 },
  createDocument: { size: 11, strokeWidth: 1.3 },
  document: { size: 13, strokeWidth: 1.2 },
  createFolder: { size: 11, strokeWidth: 1.2 },
  folder: { size: 13, strokeWidth: 1.1 },
  createDesk: { size: 11, strokeWidth: 1.2 },
  desk: { size: 13, strokeWidth: 1.2 },
  pinPanel: { size: 13, strokeWidth: 1.3 },
  search: { size: 12, strokeWidth: 1.3 },
  cut: { size: 14, strokeWidth: 1.4 },
  copy: { size: 14, strokeWidth: 1.4 },
  paste: { size: 14, strokeWidth: 1.4 },
  selectAll: { size: 14, strokeWidth: 1.4 },
  looseEnd: { size: 13, strokeWidth: 1.4 },
  parkIdea: { size: 13, strokeWidth: 1.4 },
  jumpTop: { size: 14, strokeWidth: 1.4 },
  jumpBottom: { size: 14, strokeWidth: 1.4 },
}

export function deepMergeIconStyles(persisted?: any) {
  const merged: Record<string, { size: number; strokeWidth: number }> = {}
  for (const key of Object.keys(defaultIconStyles)) {
    merged[key] = { ...defaultIconStyles[key], ...((persisted && persisted[key]) || {}) }
  }
  return merged
}
